<template>
	<page enable-flex>
		<view-list ref="view" work-type="1" view-id="10001" :search="{placeholder: '搜工单编号、产品'}">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data" @click="mp.navigateWeb('/aftersales/apply/detail', {id: data.id})">
					<template #base_state>
						<c-state dict="orderTransferStatusDic" tag :value="data.order_transfer_status"></c-state>
						<c-state dict="serviceTypeDic" tag :value="data.service_type_code"></c-state>
					</template>

					<template #aftersale_type_code>
						<c-state dict="afterSaleTypeDic" :value="data.aftersale_type_code"></c-state>
					</template>

					<template #order_transfer_status>
						<c-state dict="orderTransferStatusDic" :value="data.order_transfer_status"></c-state>
					</template>

					<template #service_progress>
						<c-state dict="serviceProgressDic" :value="data.service_progress"></c-state>
					</template>

					<template #estimated_fee>
						￥{{data.estimated_fee}}
					</template>

					<template v-if="data.service_progress" #bar>
						<div class="card-bar" style="padding: 0;">
							<c-scroll scroll-x>
								<c-steps :steps="serviceProgressDic" :active="data.service_progress" style="padding: 0;"></c-steps>
							</c-scroll>
						</div>
					</template>

					<template #operate>
						<c-button v-if="auth('b_app_aftersale_apply_transfer') && data.order_transfer_status == 0" size="detail" color="main" @click="mp.navigateWeb('/aftersales/work/edit', {source: data.id})">转售后工单</c-button>
						<c-button v-if="auth('b_app_aftersale_apply_authorize') && data.order_transfer_status == 0" @click="$refs.applyAllot.open(data.id)">分配网点</c-button>
						<c-button @click="mp.navigateWeb('/aftersales/apply/detail', {id: data.id})">查看详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>

		<apply-allot ref="applyAllot" @resolve="$refs.view.$refs.list.update()"></apply-allot>
	</page>
</template>

<script>
	import cSteps from '@/components/public/steps.vue'
	import applyAllot from './apply_allot.vue'

	export default {
		name: 'm_app_aftersale_apply',

		components: {
			cSteps,
			applyAllot
		},
		
		data() {
			return {
				serviceProgressDic:[ {
					name: '创建工单',
				}, {
					name: '指派工单',
				}, {
					name: '执行工单',
				}, {
					name: '工单完结',
				}, {
					name: '客户验收',
				}]
			}
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>